<template>
    <div id="menu-izquierda">
      <div v-for="menu in menus" v-bind:key="menu.MenuId" class="dropright show menu-izquierda" @mouseleave="menu.Mostrar = false">
        <a class="btn dropdown-toggle" role="button" aria-haspopup="true" aria-expanded="false" v-on:click="menu.Mostrar = !menu.Mostrar;" v-bind:class="{ show: menu.Mostrar }">
          <i class="d-none d-sm-none d-md-none d-lg-block d-xlg-block" :class="menu.TipoIcono.Icono"></i>
          <h2 class="enMayusculas">{{menu.Titulo}}</h2>
        </a>
        <div v-if="menu.Submenus.length > 0 && menu.Mostrar == true" class="dropdown-menu acercarAlMenu" v-bind:class="{ show: menu.Mostrar }" @mouseleave="menu.Mostrar = false">
          <div v-for="submenu in menu.Submenus" v-bind:key="submenu.SubmenuId">
            <a v-if="submenu.EsDescarga == true && submenu.SeMuestraEnVisor == false" v-on:click="AbrirDocumento(submenu.RutaParaAccesar, '_self');" class="dropdown-item" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }">{{submenu.Titulo}}</a>
            <a v-else-if="submenu.EsDescarga == true && submenu.SeMuestraEnVisor == true" v-on:click="AbreElVisor(submenu.RutaParaAccesar);" class="dropdown-item" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }">{{submenu.Titulo}}</a>
            <a v-else-if="submenu.RutaParaAccesar != null && submenu.RutaParaAccesar.includes('http')" class="dropdown-item" v-on:click="AbrirDocumento(submenu.RutaParaAccesar, '_blank');" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }">{{submenu.Titulo}}</a>
            <router-link v-else-if="submenu.RutaParaAccesar != null" :to="submenu.RutaParaAccesar" class="dropdown-item" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }">{{submenu.Titulo}}</router-link>
            <a v-else class="dropdown-item dropdown-toggle" v-on:click="submenu.Mostrar = !submenu.Mostrar;" v-bind:class="{ 'enNegritas': submenu.ResaltarElTitulo }">{{submenu.Titulo}}&nbsp;<span class="fas fa-caret-down acomodoDeCaret"></span></a>
            <div v-if="submenu.SubmenusQueMePertenecen.length > 0 && submenu.Mostrar == true">
              <SubmenusQueMePertenecen :submenu="submenu"></SubmenusQueMePertenecen>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>  
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";
import SubmenusQueMePertenecen from "@/components/PaginaOficial/PaginaPrincipal/MenuIzquierda/Submenus.vue";

  export default {
    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        PAGINA_DE_INICIO: 1,
        TIPO_POSICION: 3,
        menus: [],
        nombreDeVariableDelComponente: "cargoMenuIzquierdo"
      }
    },
    components: {
      SubmenusQueMePertenecen
    },
    methods: {
      CargaElMenu: function() {
        let parametros = {
          EsPrueba: this.enumeraciones.EsPrueba, 
          PaginaDeInicioId: this.PAGINA_DE_INICIO, 
          TipoPosicionId: this.TIPO_POSICION
        }

        axios
          .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta.data);
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            } else {
              this.menus = respuesta.data.Menus;
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
            }
          })
          .catch(excepcion => {
            console.error(excepcion);
            this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
          });
      }, 
      AbrirDocumento: function(vinculo, formaDeApertura) {
     //   console.log("abrir documento::::",vinculo)
        window.open(vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos), formaDeApertura);
      },
      AbreElVisor: function(vinculo) {
       
        this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
      YaTermineDeCargar: function(estatus) {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
      }
    },
    mounted() {
      this.CargaElMenu();
    }
  }
</script>

<style scoped>
.enMayusculas >>> {
  text-transform: uppercase;
}

.enNegritas >>> {
  font-weight: bold;
}

.acercarAlMenu {
  margin-left: 0px;
 
}

.dropright >>> {
  text-align: center;
}

.caret >>> {
  color: rgb(34,34,34)
}

h2 >>> {
  font-size: 1em;
  margin-bottom: 0;
}

.btn >>> {
  color: #fff;
}

.dropdown-toggle::after >>> {
  display: none;
}

.acomodoDeCaret > {
  font-size: 1rem !important;
}

a:hover >>> {
  color: #be9a5e !important;
}

a:active >>> {
  background-color: rgb(34, 34, 34);
  color: white !important;
}

#menu-izquierda {
  position: absolute;
  left: 1vw;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 4vh 0;
  transition: 1s all;
  transition: opacity 1s;
}

#menu-izquierda i {
  position: unset;
  margin: 15px 0;
  font-size: 4rem;
}

@media (max-width: 1600px) {
  #menu-izquierda h2 {
    font-size: 0.8em;
  }

  #menu-izquierda i {
    font-size: 4em;
  }
}

@media (max-width: 1200px) {
  #menu-izquierda h2 {
    font-size: 0.8em;
  }

  #menu-izquierda i {
    font-size: 3em;
  }
}

@media (max-width: 1024px) {
  #menu-izquierda {
    position: absolute;
    top: 3vh;
    left: 4vw;
    right: 4vw;
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
    padding: 0;
    transition: 1s all;
    transition: opacity 1s;
  }

  #menu-izquierda .menu-izquierda {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50% !important;
    padding: 0;
  }

  #menu-izquierda h2 {
    font-size: 1.2em;
  }

  #menu-izquierda i {
    font-size: 5em;
  }

  .acercarAlMenu {
    left: 5% !important;
  }
}

@media (max-width: 768px) {
  #menu-izquierda h2 {
    font-size: 0.8em;
  }

  #menu-izquierda i {
    font-size: 4em;
  }

  .menu-izquierda div {
    font-size: 0.7rem;
  }
}

@media (max-width: 600px) {
  #menu-izquierda {
    top: 16vh;
    flex-wrap: wrap;
    bottom: 10vh;
  }

  #menu-izquierda .dropright {
    width: 50%;
  }

  #menu-izquierda h2 {
    font-size: 0.6em;
  }

  #menu-izquierda i {
    font-size: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/MenuIzquierda/MenuIzquierda.vue